import { create } from 'zustand';

interface ConfirmOptions {
  message: string;
  title?: string;
  okLabel?: string;
  cancelLabel?: string;
  /** Prefixo de data-qa aplicado ao modal e derivado nos botões (`-confirmar`/`-cancelar`). */
  dataQa?: string;
}

interface ConfirmState extends ConfirmOptions {
  open: boolean;
  _resolve?: (v: boolean) => void;
  confirm: (opts: ConfirmOptions) => Promise<boolean>;
  respond: (v: boolean) => void;
}

export const useConfirm = create<ConfirmState>((set, get) => ({
  open: false,
  message: '',
  title: 'Atenção!',
  okLabel: 'Confirmar',
  cancelLabel: 'Cancelar',

  confirm(opts) {
    return new Promise<boolean>((resolve) => {
      set({
        open: true,
        title: opts.title ?? 'Atenção!',
        message: opts.message,
        okLabel: opts.okLabel ?? 'Confirmar',
        cancelLabel: opts.cancelLabel ?? 'Cancelar',
        dataQa: opts.dataQa,
        _resolve: resolve,
      });
    });
  },

  respond(v) {
    get()._resolve?.(v);
    set({ open: false, _resolve: undefined });
  },
}));

/** Açúcar: `await confirm({message})`. */
export function confirm(opts: ConfirmOptions): Promise<boolean> {
  return useConfirm.getState().confirm(opts);
}
